import { useState } from 'react';

/**
 * Hook to manage modal state for AssignedQueries page
 * @returns {Object} Modal state and handlers
 */
export const useAssignedQueriesPageModals = () => {
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [escalateDialogOpen, setEscalateDialogOpen] = useState(false);
  const [escalateTarget, setEscalateTarget] = useState(null);
  const [escalatingId, setEscalatingId] = useState(null);
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [assignTarget, setAssignTarget] = useState(null);
  const [assigningId, setAssigningId] = useState(null);

  const handleOpenViewModal = (query) => {
    setSelectedQuery(query);
    setViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setViewModalOpen(false);
    setSelectedQuery(null);
  };

  const handleOpenEscalateDialog = (query) => {
    if (!query) return;
    setEscalateTarget(query);
    setEscalateDialogOpen(true);
  };

  const handleCloseEscalateDialog = () => {
    if (escalatingId === escalateTarget?._id) return;
    setEscalateDialogOpen(false);
    setEscalateTarget(null);
  };

  const handleOpenAssignDialog = (query) => {
    setAssignTarget(query);
    setAssignDialogOpen(true);
  };

  const handleCloseAssignDialog = () => {
    setAssignDialogOpen(false);
    setAssignTarget(null);
    setAssigningId(null);
  };

  return {
    viewModalOpen,
    selectedQuery,
    escalateDialogOpen,
    escalateTarget,
    escalatingId,
    assignDialogOpen,
    assignTarget,
    assigningId,
    setViewModalOpen,
    setSelectedQuery,
    setEscalateDialogOpen,
    setEscalateTarget,
    setEscalatingId,
    setAssignDialogOpen,
    setAssignTarget,
    setAssigningId,
    handleOpenViewModal,
    handleCloseViewModal,
    handleOpenEscalateDialog,
    handleCloseEscalateDialog,
    handleOpenAssignDialog,
    handleCloseAssignDialog,
  };
};
